module.exports = __webpack_public_path__ + "static/media/4552.b9fa35a5.jpg";